export default __webpack_public_path__ + "static/media/powerpointTemplate.603a0dd4.jpg";